import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PageHeading } from '../components/PageHeader';
import { AgencyCopyTab } from '../components/Agency/AgencyCopyTab';
import { useToolAccess } from '../hooks/useToolAccess';

/** Tools → Copy (ADR 0031): AI settings from one Account to others. Each copied item
 *  still checks its own permission on the source and every target (routes/agency.py). */
export function CopyPage() {
  const { t } = useTranslation('agency');
  const tools = useToolAccess();
  if (!tools) return null;
  if (!tools.usable.copy) return <Navigate to="/" replace />;

  return (
    <div className="mobile-page-shell cpt-root w-full px-6 pt-5 pb-6 min-w-0" style={{ display: 'flex', flexDirection: 'column', gap: 14, boxSizing: 'border-box' }}>
      <PageHeading title={t('tabs.copy')} subtitle={t('pages.copySubtitle')} />
      <AgencyCopyTab />
    </div>
  );
}
